var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        transition: "dialog-top-transition",
        "max-width": 600,
        "max-height": 900
      },
      model: {
        value: _vm.value,
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { staticClass: "primary white--text" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.viewOnly ? "Center Details" : "Edit Center") +
                  "\n      "
              ),
              _c("v-icon", {
                staticClass: "ml-5",
                attrs: { color: "white" },
                domProps: { textContent: _vm._s("mdi-information-outline") },
                on: {
                  mouseover: function($event) {
                    _vm.showHint = true
                  },
                  mouseleave: function($event) {
                    _vm.showHint = false
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.showHint
            ? _c("div", { staticClass: "ml-10 mt-10" }, [
                _c(
                  "p",
                  { staticStyle: { color: "black", "font-weight": "bolder" } },
                  [_vm._v("Info:")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "ml-10 mr-5",
                    staticStyle: { color: "black", "margin-top": "-1em" }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.hint) + "\n      ")]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pa-5" },
            [
              _c("v-text-field", {
                attrs: { label: "Name", outlined: "" },
                model: {
                  value: _vm.center.name,
                  callback: function($$v) {
                    _vm.$set(_vm.center, "name", $$v)
                  },
                  expression: "center.name"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "City", outlined: "" },
                model: {
                  value: _vm.center.city,
                  callback: function($$v) {
                    _vm.$set(_vm.center, "city", $$v)
                  },
                  expression: "center.city"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: { label: "Country", outlined: "" },
                model: {
                  value: _vm.center.country,
                  callback: function($$v) {
                    _vm.$set(_vm.center, "country", $$v)
                  },
                  expression: "center.country"
                }
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  label: "Province",
                  outlined: "",
                  hint: "Optional",
                  "persistent-hint": true
                },
                model: {
                  value: _vm.center.province,
                  callback: function($$v) {
                    _vm.$set(_vm.center, "province", $$v)
                  },
                  expression: "center.province"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-center" },
            [
              !_vm.viewOnly
                ? _c("AppButton", {
                    attrs: {
                      xLarge: "",
                      disabled: _vm.doesCenterHaveEmptyFields()
                    },
                    domProps: { textContent: _vm._s("Edit") },
                    on: {
                      click: function($event) {
                        return _vm.handleEdit()
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("AppButton", {
                staticClass: "secondary",
                attrs: { xLarge: "" },
                domProps: { textContent: _vm._s("Close") },
                on: {
                  click: function($event) {
                    return _vm.$emit("input", false)
                  }
                }
              }),
              _vm._v(" "),
              _vm.$auth.user.role === _vm.Role.Admin
                ? _c("AppButton", {
                    attrs: { xLarge: "" },
                    domProps: { textContent: _vm._s("Delete") },
                    on: {
                      click: function($event) {
                        return _vm.handleDeleteCenter()
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }